/** What the one-click Make 3D button sends; the agent prompt recognises it. */
export const MAKE_3D_REQUEST = "Make 3D from this drawing.";
